import Vue from 'vue'
import VueRouter from 'vue-router'

// import Home from '@/views/Home.vue'
const routesAll = require('../router/routes');
/**
 * BASIC IMPORTS REPLACED BY IMPORT ROUTE 
import Account from '@/views/Account'
import Welcomer from '@/views/Welcomer.vue'
import Articles from '@/views/Articles.vue'
import Extension from '@/views/Extension.vue'
import Write from '@/views/Write.vue'
import LoginPage from '@/views/LoginPage'
import Search from '@/views/Search'
import Feeds from '@/views/FEEDS'
// import store from '../store'
import goTo from 'vuetify/es5/services/goto'
 */

Vue.use(VueRouter);

const routes = routesAll;

export default new VueRouter({
  mode: 'history',
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    // this.$store.dispatch("setHistory");
    // store.commit("setHistory", from, to);
    if (to.hash !== "")
      if (document.querySelector(to.hash))
        return { x: 0, y: document.querySelector(to.hash).offsetTop - 50 }
    // let instant  = {to:to, from:from, savedPosition:savedPosition};
    return new Promise((resolve, reject) => {
      if (reject) resolve({ x: 0, y: 0 })
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  }
});
// router;
// return router;
// export default router





